import PropTypes from 'prop-types';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
   
return (
    <DrawerHeaderStyled
      open={open}
      sx={{
          bgcolor: '#FFFFFF',
          color: '#333333',
          '& .simplebar-content': {
            display: 'flex',
            flexDirection: 'column',
            bgcolor: '#FFFFFF',
            color: '#333333'
          },
          '& .simplebar-wrapper': {
            bgcolor: '#FFFFFF',
            color: '#333333'
          },
          '& .simplebar-scroll-content': {
            bgcolor: '#FFFFFF',
            color: '#333333'
          }
        }}
    >
      <Logo isIcon={!open} sx={{ width: open ? 'auto' : 35, height: 35 }} />
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
